module.exports = __webpack_public_path__ + "img/logo.107c89bc.png";